export default __webpack_public_path__ + "static/media/logo-swissmarkets.82a7b256.svg";